const Dropzone = require('dropzone');

Dropzone.autoDiscover = false;

Vue.directive('dropzone', {
  bind (el, bindings) {
    el.classList.add('dropzone');
    const options = bindings.value;

    let message = '';
    message += options.faIcon ? (`<span class="dropzone-icon" ><i class="fa ${options.faIcon}"></i></span>`) : '';
    message += options.defaultMessage ? options.defaultMessage : '';

    const accept = function (file, done) {
      const regex = new RegExp('^.*\\.(csv|CSV)$');

      if (regex.test(file.name)) {
        return done();
      }

      done('Envie o arquivo no formato CSV');
    };

    var dropzone = new Dropzone(el, {
      url: options.action,
      paramName: 'file', // The name that will be used to transfer the file
      maxFilesize: options.maxFilesize ? options.maxFilesize : 10, // MB
      dictDefaultMessage: message,
      accept: options.accept || accept,

      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
      },

      success (e) {
        if (options.success) {
          options.success(e);
        }
      },

      error (e) {
        if (options.error) {
          options.error(e);
          dropzone.removeAllFiles();
        }
      },
    });

    dropzone.on("sending", function(file, xhr, formData) {
      // Will send the filesize along with the file as POST data.
      formData.append("isFilePublic", options.isFilePublic);
    });

    dropzone.on("complete", function(file) {
      dropzone.removeFile(file);
    });
  },
});
